import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  size?: 'default' | 'large';
  showPlayIcon?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  size = 'default',
  showPlayIcon = true,
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg';
  return <motion.button onClick={onClick} className={`
        inline-flex items-center justify-center gap-3
        bg-gold text-navy font-heading font-bold
        rounded-lg gold-glow
        transition-all duration-300
        hover:bg-gold-hover hover:scale-[1.02]
        active:scale-[0.98]
        ${sizeClasses}
        ${className}
      `} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} data-id="element-15">
      {showPlayIcon && <PlayIcon className="w-5 h-5 fill-current" aria-hidden="true" data-id="element-16" />}
      {children}
    </motion.button>;
}